import React, { useRef, useState, useEffect } from 'react';
import { Card, Badge, Button, Spinner } from 'react-bootstrap';
import { Users, ChevronLeft, ChevronRight } from 'lucide-react';
import { collection, getDocs ,query,where} from 'firebase/firestore';
import { db } from '../FireBase';
import '../css/RelatedRooms.css';
import FetRoomCard from './FetRoomCard';

const RelatedRooms = ({ currentRoomId }) => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const carouselRef = useRef(null);
   const [bookingCounts, setBookingCounts] = useState({});
   const STORAGE_KEY = 'bookingSearch';
  const [range, setRange]= useState({ from: undefined, to: undefined });

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const { from, to } = JSON.parse(saved);
        setRange({
          from: from ? new Date(from) : undefined,
          to:   to   ? new Date(to)   : undefined,
        });
      } catch (err) {
        console.error('Invalid date range in localStorage', err);
      }
    }
  }, []);
  
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        setLoading(true);
  
        const snapshot = await getDocs(collection(db, 'rooms'));
        const data = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(room => room.id !== currentRoomId); // exclude current room
  
        setRooms(data);
  
        // only fetch bookings if date range is selected
        if (range.from && range.to) {
          const roomIds = data.map(room => room.id);
          fetchBookings(roomIds);
        } else {
          setBookingCounts({}); // reset if no dates
        }
      } catch (error) {
        console.error('Error fetching rooms:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchRooms();
  }, [range, currentRoomId]);
  

        const formatDateForOrder = (date) => {
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  const fetchBookings = async (roomIds) => {
       const today = new Date();
       const tomorrow = new Date(today);
       tomorrow.setDate(today.getDate() + 1);
       const checkinISO = formatDateForOrder(range.from);
       const checkoutISO =formatDateForOrder(range.to);
   
       const bq = query(
         collection(db, 'room_bookings'),
         where('checkIn', '<', checkoutISO),
         where('checkOut', '>', checkinISO),
         where('status', '==', 'booking-confirmed')
       );
       const snap = await getDocs(bq);
       const counts = {};
       snap.docs.forEach(doc => {
         const { roomId ,roomCount = 1 } = doc.data();
         if (roomIds.includes(roomId)) {
           counts[roomId] = (counts[roomId] || 0) + roomCount;
         }
       });
       setBookingCounts(counts);
     };


  const scroll = direction => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth;
      carouselRef.current.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    }
  };

  if (loading) {
    return (
      <div className="related-rooms py-5 text-center">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <section className="related-rooms pb-5 position-relative">
      <div className="container">
        <h2 className="section-title">You may like!</h2>

       

        <div ref={carouselRef} className="carousel-container">
          {rooms.map(room => (
            <FetRoomCard key={room.id} room={room} bookingCount={bookingCounts[room.id] || 0} />
          ))}
        </div>

     
      </div>
    </section>
  );
};

export default RelatedRooms;